export default function Error() {
  return <h2 className="mt-5">404 - PAGE NOT FOUND</h2>;
}
